import type { ReactNode } from "react";
import { WaggleMark } from "@/components/waggle/WaggleLogo";
import { HeroCard } from "@/components/waggle/HeroCard";

/**
 * Full-viewport shell for "something went wrong" pages (404, render crash).
 * No sidebar or auth context needed, so it is safe to render from anywhere,
 * including inside the ErrorBoundary.
 */
export function ErrorPage({
  icon,
  title,
  description,
  eyebrow,
  actions,
  tone = "muted",
  children,
  "data-testid": testId,
}: {
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  actions?: ReactNode;
  tone?: "brand" | "muted" | "warning";
  /** Extra content under the card, e.g. dev-only error details. */
  children?: ReactNode;
  "data-testid"?: string;
}) {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-background p-6">
      <WaggleMark className="h-12 w-12" />
      <div className="w-full max-w-xl space-y-4">
        <HeroCard
          tone={tone}
          icon={icon}
          title={title}
          description={description}
          eyebrow={eyebrow}
          actions={actions}
          data-testid={testId}
        />
        {children}
      </div>
    </div>
  );
}
